<template>

    <span>
        <span v-for="domainable_attribute in domainable_attributes">
            <span
                    @dblclick="change_activity(domainable_attribute.domain.id)"
                    :class="'b-admin-domain__label small ' + domainable_attribute.domain.code + ' cursor-pointer'"
            >
                {{domainable_attribute.domain.short_title}}
            </span>
            <span class="b-admin-table__icon-true" v-if="domainable_attribute.is_active == true">
                <i class="fa fa-check"></i>
            </span>
            <span v-else class="b-admin-table__icon-false">
                <i class="fa fa-times"></i>
            </span>
        </span>
    </span>

</template>

<script>
    export default {
        props: ['domainable_attributes', 'entity_id', 'current_route'],
        mounted: function() {
            Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('content');
        },
        methods: {
            change_activity: function (domain_id) {
                this.$http.post(this.current_route + '/' + this.entity_id + '/change_activity', { domain_id: domain_id})
                    .then(function () {
                        this.$root.$emit('update-table');
                    }, function (response) {
                        console.log(response);
                    });
            }
        }
    }
</script>
